import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import Layout from '@src/components/layout/Layout';

import { useNavigate } from 'react-router-dom';
import HospitalUserForm from './components/HospitalUserForm';
import { useHospitalUserForm } from './hooks/useHospitalUserForm';
import { useUpdateHospitalUserLazy } from '@src/adapters/hooks/hospital/useUpdateHospitalUser';
import { useSnackbar } from 'notistack';

const FORM_ID = 'hospital-user-edit-form';

function HospitalUserEdit() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { execute: updateHospitalUser } = useUpdateHospitalUserLazy();

  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    roles,
    setRoles,
    formState: { errors, isDirty },
    userSlug,
    currentHospital,
    fullName,
  } = useHospitalUserForm();

  const handleCancel = () => {
    reset();
    navigate(-1);
  };

  const onSubmit = handleSubmit(async (data) => {
    if (!isDirty) {
      navigate(-1);
      return;
    }

    try {
      await updateHospitalUser({
        userId: userSlug,
        hospitalId: currentHospital?.id!,
        firstName: data.firstName,
        lastName: data.lastName,
        roles,
        registrationNumber: data.gmcNumber,
        professionalBodyId: data.professionalBodyId,
      });

      enqueueSnackbar('User edited', {
        variant: 'success',
      });
      navigate(-1);
    } catch (error) {
      console.error('Failed to update hospital user', error);
    }
  });

  const proffesionalBodyId = watch('professionalBodyId');

  return (
    <Layout>
      <Box sx={{ margin: 'auto', width: 949, px: 2 }}>
        <Stack direction={'row'} justifyContent="space-between" mb={4}>
          <Typography variant="h4">{fullName}</Typography>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              onClick={handleCancel}
              variant="outlined"
              size="large"
              color="primary">
              Cancel
            </Button>

            <Button
              type="submit"
              form={FORM_ID}
              variant="contained"
              size="large"
              color="primary">
              Finish
            </Button>
          </Box>
        </Stack>

        <Paper>
          <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="h6">User details</Typography>
          </Box>

          <Box
            sx={{
              pb: 2,
            }}>
            <HospitalUserForm
              formId={FORM_ID}
              control={control}
              register={register}
              onSubmit={onSubmit}
              readOnly={false}
              roles={roles}
              setRoles={setRoles}
              errors={errors}
              currentProfessionalBodyId={proffesionalBodyId}
            />
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
}

export default HospitalUserEdit;
